import { render, staticRenderFns } from "./LvDocxViewer.vue?vue&type=template&id=108f7c11"
import script from "./LvDocxViewer.vue?vue&type=script&lang=js"
export * from "./LvDocxViewer.vue?vue&type=script&lang=js"
import style0 from "@/__common/scss/lv-docx-viewer.scss?vue&type=style&index=0&prod&lang=scss&module=true&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports